import { storage, Key } from '@soluto-private/mx-context';
var MxContextLanguageDetector = /** @class */ (function () {
    function MxContextLanguageDetector() {
    }
    MxContextLanguageDetector.prototype.init = function (_services, _detectorOptions, _i18nextOptions) { };
    MxContextLanguageDetector.prototype.cacheUserLanguage = function (lng) {
        // called on init and i18next.changeLanguage()
        var currentCachedLanguage = storage.get(Key.Language);
        if (lng !== currentCachedLanguage) {
            storage.set(Key.Language, lng);
        }
    };
    MxContextLanguageDetector.prototype.detect = function () {
        return storage.get(Key.Language) || navigator.language;
    };
    MxContextLanguageDetector.type = 'languageDetector';
    return MxContextLanguageDetector;
}());
export { MxContextLanguageDetector };
